<template>
  <v-container fluid>
    <v-row>
      <!--stepper-input /-->
      <v-col cols="12" md="9">
        <v-card style="margin-bottom:1em;">
          <v-card-title class="title" style="color:white;background-color:#0a182a;">
            <span class="font-weight-bold" style="font-size:1.5rem; padding-right:5px;">{{ $t('step1_title') }}</span>
            <span>{{ $t('step1_description') }}</span>
            <span style="white-space:pre;"> (<a v-on:click="showoverlay = true" style="color:#178ccb;">{{ $t('step1_unsure') }}</a>)</span>
          </v-card-title>
          <v-card-text>
            <multi-source />
          </v-card-text>
        </v-card>

        <v-card>
          <v-card-title class="title" style="color:white; background-color: #0a182a;">
            <span class="font-weight-bold" style="font-size:1.5rem; padding-right:5px;">{{ $t('step2_title') }}</span>
            {{ $t('step2_description') }}
            <v-btn
              style = "margin-left:1em;"
              @click = "reset_supply_only"
              small
            >
              Reset
            </v-btn>
          </v-card-title>
          <v-expansion-panels multiple focusable v-model="expanded_source">
            <plant v-if="selected_supply_only_plant === true" />
            <concentrator v-if="selected_supply_only_concentrator === true" />
            <liquid v-if="selected_supply_only_liquid === true" />
            <cylinder v-if="selected_supply_only_cylinder === true" />
          </v-expansion-panels>
        </v-card>
      </v-col>
      <v-col sm="12" class="d-md-none">
        <summary-statistics />
      </v-col>
      <v-col md="3" class="d-none d-md-flex statistic-container" justify="center">
        <summary-statistics />
      </v-col>
      <v-overlay :value="showoverlay" v-on:click.native="showoverlay = false">
        <v-btn
          icon
          @click="showoverlay = false"
        >
          x
        </v-btn>
        <source-helper />
      </v-overlay>
      <v-overlay :value="showoverlay_cylinder" v-on:click.native="showoverlay_cylinder = false">
        <v-btn
          icon
          @click="showoverlay_cylinder = false"
        >
          x
        </v-btn>
        <cylinder-helper />
      </v-overlay>
    </v-row>

    <v-row class="justify-center d-print-none">
      <!--v-btn tile x-large outlined @click="print">
        <icon-print />
        {{ $t('Print') }}
      </v-btn-->
      <v-btn tile x-large outlined @click="download">
        <icon-save />
        {{ $t("Save") }}
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { csv } from 'd3-fetch';
// @ is an alias to /src

import MultiSource from '@/components/MultiSourceSupplyOnly.vue'
import Liquid from '@/components/LiquidSupplyOnly.vue'
import Plant from '@/components/PlantSupplyOnly.vue'
import Cylinder from '@/components/CylinderSupplyOnly.vue'
import Concentrator from '@/components/ConcentratorSupplyOnly.vue'

import SummaryStatistics from '@/components/SummaryStatisticsSupplyOnly.vue'
import SourceHelper from '@/components/SourceHelper4.vue'
import CylinderHelper from '@/components/CylinderHelper.vue'

import IconSave from '@/components/IconSave.vue'

const download_csv = function(arr) {
  var str = '';
  arr.forEach(rw => {
    let line = '';
    line = rw.join(",");
    str += line + '\r\n';
  });
  var blob = new Blob([str], { type: 'text/csv;charset=utf-8;' });

  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', 'oxygen_demand_history.csv');
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

const cylinder_lookup = {
  'Size C': 170,
  'Size D': 340,
  'Size E': 680,
  'Size F': 1360,
  'Size G': 4100,
  'Size H': 6600,
  'Size J': 6800,
  'Size K': 7100,
  '7500L': 7500,
}

export default {
  name: 'HomeSupply',

  components: {
    MultiSource,
    Liquid,
    Plant,
    Cylinder,
    CylinderHelper,
    Concentrator,
    SummaryStatistics,
    SourceHelper,
    IconSave,
  },

  data: () => ({
    supply_type: null,
    expanded_source: []
  }),

  computed: {
    ...mapFields([
      'selected_supply_only_plant',
      'selected_supply_only_concentrator',
      'selected_supply_only_liquid',
      'selected_supply_only_cylinder',
      'showoverlay',
      'showoverlay_cylinder',
      'sources',
      'source',
      'distribution',
      'period',
      'leakage',
      'supply_types',
      'calculator',
      'plant_table_editable',
      'concentrator_table_editable',
      'liquid_table_editable',
      'cylinder_table_editable',
      'hours_plant_supply_only',
      'leakage_plant_supply_only',
      'hours_concentrator_supply_only',
      'leakage_concentrator_supply_only',
      'leakage_liquid_supply_only',
      'leakage_cylinder_supply_only'
    ])
  },

  watch: {
    source: function() {
      if(this.source === 'Portable Oxygen Concentrator (PSA)') {
        // change to per minute default for concentrator
        this.period = 'per minute'
        // set leakage to 0 with concentrator since we will not include this input
        this.leakage = 0
      }
    },
    supply_type: function() {
      if(this.supply_type !== null) {
        if(this.source === "Portable Oxygen Concentrator (PSA)") {
          this.$store.commit('changeAmount', this.supply_type.lpm)
          this.$store.commit('changeUnit', "liters")
        }
        if(this.source === "Liquid Oxygen (VIE)") {
          this.$store.commit('changeAmount', this.supply_type.lpm)
          this.$store.commit('changeUnit', "liters")
        }
      }
    },
  },

  methods: {
    get_supply_types: function() {
      let types = this.supply_types ? this.supply_types.filter((d) => d.Manufacturer !== '') : []
      if(types.length === 0) {
        return types
      }
      if(this.source === "Oxygen Plant (PSA)") {
        return types.filter( d => d["Oxygen supply type"] === "PSA Plant" || d["Oxygen supply type"] === "")
      }
      if(this.source === "Portable Oxygen Concentrator (PSA)") {
        return types.filter( d => d["Oxygen supply type"] === "Portable PSA" || d["Oxygen supply type"] === "")
      }
      if(this.source === "Liquid Oxygen (VIE)") {
        return types.filter( d => d["Oxygen supply type"] === "Liquid Oxygen" || d["Oxygen supply type"] === "")
      }
    },
    download: function() {
      const instance = this,
        calcPlantSupply = this.calcPlantSupply,
        calcConcentratorSupply = this.calcConcentratorSupply,
        calcLiquidSupply = this.calcLiquidSupply,
        calcCylinderSupply = this.calcCylinderSupply

      let export_dat = [["type", "device", "number", "rate", "supply", "leakage", "hours"]] //.map(x => this.$t(x))]

      if(this.selected_supply_only_plant) {
        if(Array.isArray(this.plant_table_editable) && this.plant_table_editable.length > 0) {
          this.plant_table_editable.forEach(function(d) {
            if(d.type) {
              export_dat.push([
                'plant',
                '"' + d.type['Manufacturer'] + ' ' + d.type['Model'] + '"',
                d.num_plant,
                d.liters,
                calcPlantSupply(d),
                instance.leakage_plant_supply_only,
                instance.hours_plant_supply_only,
              ])
            }
          })
        }
      }

      if(this.selected_supply_only_concentrator) {
        if(Array.isArray(this.concentrator_table_editable) && this.concentrator_table_editable.length > 0) {
          this.concentrator_table_editable.forEach(function(d) {
            if(d.type) {
              export_dat.push([
                'concentrator',
                '"' + d.type['Manufacturer'] + ' ' + d.type['Model'] + '"',
                d.num_concentrator,
                d.liters,
                calcConcentratorSupply(d),
                instance.leakage_concentrator_supply_only,
                instance.hours_concentrator_supply_only,
              ])
            }
          })
        }
      }

      if(this.selected_supply_only_liquid) {
        if(Array.isArray(this.liquid_table_editable) && this.liquid_table_editable.length > 0) {
          this.liquid_table_editable.forEach(function(d) {
            if(d.type) {
              export_dat.push([
                'liquid',
                '"' + d.type['Manufacturer'] + ' ' + d.type['Model'] + '"',
                d.num_liquid,
                d.liters,
                calcLiquidSupply(d),
                instance.leakage_liquid_supply_only,
              ])
            }
          })
        }
      }
      
      if(this.selected_supply_only_cylinder) {
        if(Array.isArray(this.cylinder_table_editable) && this.cylinder_table_editable.length > 0) {
          this.cylinder_table_editable.forEach(function(d) {
            if(d.cylinder) {
              export_dat.push([
                'cylinder',
                '"' + d.cylinder + '"',
                d.num_cylinders,
                cylinder_lookup[d.cylinder.slice(0,6)] ? cylinder_lookup[d.cylinder.slice(0,6)] : 0,
                calcCylinderSupply(d),
                instance.leakage_cylinder_supply_only,
              ])
            }
          })
        }
      }

      download_csv(export_dat)
    },
    calcPlantSupply (item) {
      return +item.num_plant * item.liters * 60 * this.hours_plant_supply_only * ( 100 - this.leakage_plant_supply_only ) / 100
    },
    calcConcentratorSupply(item) {
      return +item.num_concentrator * item.liters * 60 * this.hours_concentrator_supply_only * ( 100 - this.leakage_concentrator_supply_only ) / 100
    },
    calcLiquidSupply (item) {
      return +item.num_liquid * item.liters * 861 * ( 100 - this.leakage_liquid_supply_only ) / 100
    },
    calcCylinderSupply (item) {
      if(item.cylinder) {
        window.console.log(
          item.num_cylinders,
          item.cylinder,
          cylinder_lookup,
          this.leakage_cylinder_supply_only
        )
        return (item.num_cylinders * cylinder_lookup[item.cylinder.slice(0,6)]) * ( 100 - this.leakage_cylinder_supply_only ) / 100
      } else {
        return 0
      }
    },
    reset_supply_only: function() {
      this.$store.commit('resetSupplyOnly')
    }
  },

  mounted: function() {
    let instance = this;
    csv('./supply_types.csv')
      .then( (result) => {
        instance.supply_types = result
      })
      .finally(function(e) {e})
  },

  beforeRouteEnter: (to, from, next) => {
    let name = to.name.toLowerCase()
    let lang = to.query.lang
    next(vm => {
      vm.$store.commit('changeCalculator', name)
      vm.$store.commit('changeLocale', lang)
    })
  }
}
</script>

<style scoped>
  .statistic-container {
    max-height: 85vh;
    position: -webkit-sticky;
    position: sticky;
    top: 4rem;
  }
</style>